import Image from 'next/image'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { customerId } from '@/utils/env'

const LOGO_ROUTES = '/logos'
const { CUSTOMER_IDS } = customerHelper

const getDefaultLogoConfig = brand => ({ src: `${LOGO_ROUTES}/${brand.toLowerCase()}.png` })
const logoConfigByCustomer = {
  [CUSTOMER_IDS.TME]: getDefaultLogoConfig,
  [CUSTOMER_IDS.SUBARU]: getDefaultLogoConfig,
  [CUSTOMER_IDS.NORDICS]: () => ({ src: `${LOGO_ROUTES}/nordics.png`, aspectRatio: 1500 / 235 })
}

const BrandLogo = ({ brand, onClick, href = '#', height = 36, width = 50 }) => {
  const getLogoConfig = logoConfigByCustomer[customerId] || logoConfigByCustomer[CUSTOMER_IDS.TME]
  const logoConfig = getLogoConfig(brand)
  const logoHeight = logoConfig.aspectRatio ? Math.round(width / logoConfig.aspectRatio) : height
  const image = (
    <Image
      id={`brand-logo-${brand.toLowerCase()}`}
      src={logoConfig.src}
      alt={`${brand} logo`}
      height={logoHeight}
      width={width}
      title={`${brand} logo`}
    />
  )

  if (onClick) {
    return (
      <div
        onClick={onClick}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onClick(e)}
        role="button"
        tabIndex={0}
        href={href}
        style={{ cursor: 'pointer' }}
        aria-label={`Go to ${brand} homepage`}
      >
        {image}
      </div>
    )
  }

  return image
}

export default BrandLogo
